export default __webpack_public_path__ + "static/media/check_box_unchecked.f158bb54.svg";